import { render, staticRenderFns } from "./ListPlatforms.vue?vue&type=template&id=e6ed04fa&"
import script from "./ListPlatforms.vue?vue&type=script&lang=js&"
export * from "./ListPlatforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports